// El código de este archivo se cargará en todas las páginas de tu sitio

$w.onReady(function () {Write});